import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import { slotStore} from '@gongxigames/framework/slotV2/globals';
import {LogicEvents, RealityCheckEvents, SlotSettings} from '@gongxigames/framework/slot';
import {setAutoplaySpinsToZero, listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class AutoplayIdleUIAct extends SyncUIActDecorator {
    public execute(): void {
        listenUIDisabled(this);

        this.emitter.on('Game.command.canProceedAutoSpin', () => {
            this.onExecuted?.();
        });

        this.emitter.on('UI.stopAutoplayButton.pressed', () => {
            this.stopAutoplay();
            this.onExecuted?.();
        });

        this.emitter.on('UI.quickStopButton.pressed', this.onSkipStartedByButton.bind(this));

        this.eventManager.on(LogicEvents.REALITY_CHECK, () => {
            this.stopAutoplay();
            this.onExecuted?.();
        }, this);

        this.eventManager.on(RealityCheckEvents.SHOWED, () => {
            this.stopAutoplay();
            this.onExecuted?.();
        }, this);

        this.eventManager.on('Autoplay.STOP', () => {
            this.stopAutoplay();
            this.onExecuted?.();
        }, this);
    }

    protected stopAutoplay(): void {
        setAutoplaySpinsToZero();
        slotStore.batchUpdate({
            isAutoplay: false
        });
        (this.settings as SlotSettings).set('autoplayMode', false);
        this.eventManager.emit('Autoplay.STOPPED');
        this.emitter.emit('Autoplay.STOPPED');
        this.emitter.emit('UI.disableSpinAutoMode');
    }

    protected onSkipStartedByButton(): void {
        this.emitter.emit('UI.command.spin');
    }

    getName(): string {
        return 'AutoplayIdleUIAct';
    }
}